var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "53px",
    viewBox: "0 0 81 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.76772739e-15%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66CA6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F799BD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.0637475%",
    y1: "39.9561095%",
    x2: "-0.622556243%",
    y2: "29.2206211%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F795BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76CA6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.48895755e-15%",
    y1: "2.73193117%",
    x2: "100%",
    y2: "97.2680688%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F577A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F65A92",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockups-(2)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Minimal",
    transform: "translate(-257.000000, -174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(255.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(2.500000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0472007,46.0467557 C44.0472007,46.0467557 38.6970383,40.5462073 30.095781,40.0318761 C24.0311454,39.669049 19.3764482,37.9941183 19.3764482,37.9941183 C25.3691519,48.1042668 33.7085848,45.9053146 44.0472007,46.0467557 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4146453,2.64934982 C35.4146453,2.64934982 16.7493294,10.1785492 0,6.17599219 C0,6.17599219 4.31792218,25.3031747 30.0792405,29.7939744 C53.7473944,33.9195238 55.3844262,45.6820702 55.3844262,45.6820702 L60.7040628,26.2793732 L35.4146453,2.64934982 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2993362,5.75689914 C33.9529032,3.91881965 35.8315755,2.17098352 37.9759456,0.529158187 C38.9471521,-0.217278547 40.3115378,-0.169305309 41.227726,0.64322043 C44.4271719,3.47196404 48.2267865,5.45765349 52.7852504,6.37753193 C53.3075884,6.48253629 53.8440164,6.4986392 54.371722,6.42449874 C56.3369474,6.14873649 61.6827763,5.39827403 64.9399243,4.94101863 C65.4897714,4.86385888 66.039283,5.08359643 66.384489,5.51871034 C66.729695,5.95382425 66.818261,6.53923193 66.6179811,7.05720871 C65.6967608,9.43674837 64.348478,12.9186661 63.6610852,14.6966951 C63.3692201,15.4511833 63.5074367,16.2680703 63.3906906,17.0681833 C62.0128858,26.5316592 81.9362048,46.6002398 79.846182,50.9701656 C77.7558236,55.3400914 56.7626679,50.016404 50.8492116,43.2877381 C49.8766632,42.1813344 48.6407653,40.9051792 47.2341095,39.5163036 C46.2592128,38.5538196 45.1276482,37.4796216 44.2909681,36.6711216 C42.3619743,34.8360614 40.2702741,32.8886164 38.182935,30.9314425 C35.5551423,28.4009381 34.882846,27.7534671 30.3133113,23.3530129 C29.0589621,22.0839027 27.9143139,20.8758494 26.9367334,19.763407 C26.4637106,19.2253016 26.1305817,18.6003076 25.9427145,17.9394176 C26.2996622,11.4573274 29.0633233,11.9592013 32.2993362,5.75689914 Z",
    id: "SVGID_2_",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f624f1bd0e1e09976fb44343afcc890b.svg";
export { ForwardRef as ReactComponent };